export default "__VITE_ASSET__d62f4f9c__"